import { render, staticRenderFns } from "./PartnerCurrentWithholdEdit.vue?vue&type=template&id=09f7432c&scoped=true&"
import script from "./PartnerCurrentWithholdEdit.vue?vue&type=script&lang=js&"
export * from "./PartnerCurrentWithholdEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f7432c",
  null
  
)

export default component.exports